module.exports = __webpack_public_path__ + "img/grid-sample9.35c0453e.jpg";